import { Cloud, CloudOff, Check, Loader2, AlertCircle } from 'lucide-react';
import { SaveStatus } from '../../types';
import { useAuth } from '../../pages/Auth/AuthProvider';
import { useSaveStatus } from '../../context/SaveStatusContext';

const base = 'flex items-center gap-1.5 px-2 py-1 rounded-md text-[11.5px] font-medium';

/**
 * Save state for the open diagram, shown in the tab strip. Renders nothing
 * unless a diagram is actually open.
 */
export function SaveStatusPill() {
  const { saveStatus } = useSaveStatus();
  const { isAuthenticated } = useAuth();

  if (saveStatus === null) return null;

  if (!isAuthenticated) {
    return (
      <div className={`${base} text-muted-foreground`}>
        <CloudOff className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Not signed in</span>
      </div>
    );
  }

  switch (saveStatus) {
    case SaveStatus.SAVING:
      return (
        <div className={`${base} text-blue-600 dark:text-blue-400`}>
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
          <span className="hidden sm:inline">Saving…</span>
        </div>
      );
    case SaveStatus.SAVED:
      return (
        <div className={`${base} text-emerald-600 dark:text-emerald-400`}>
          <Check className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Saved</span>
        </div>
      );
    case SaveStatus.ERROR:
      return (
        <div className={`${base} text-destructive`}>
          <AlertCircle className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Error</span>
        </div>
      );
    case SaveStatus.UNSAVED:
      return (
        <div className={`${base} text-amber-600 dark:text-amber-400`}>
          <Cloud className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Unsaved</span>
        </div>
      );
    default:
      return null;
  }
}
